export const colors = {
  red: "#C1121F",
  redDark: "#960F1A",
  redSoft: "rgba(193,18,31,0.08)",
  ink: "#1a1a1a",
  body: "#4b4b4b",
  muted: "#8a8a8a",
  faint: "#b7b7b7",
  bg: "#ffffff",
  bgAlt: "#f6f6f4",
  bgDark: "#1c1c1c",
  border: "rgba(20,20,20,0.09)",
  borderStrong: "rgba(20,20,20,0.16)",
  whatsapp: "#25D366",
};

export const fontHeading = "'Poppins', 'Segoe UI', sans-serif";
export const fontBody = "'Inter', 'Segoe UI', sans-serif";

export const globalCss = `
  * { box-sizing: border-box; }
  html { scroll-behavior: smooth; }
  body { margin: 0; overflow-x: hidden; background: ${colors.bg}; }
  ::selection { background: ${colors.redSoft}; color: ${colors.ink}; }
  ::-webkit-scrollbar { width: 8px; }
  ::-webkit-scrollbar-track { background: ${colors.bgAlt}; }
  ::-webkit-scrollbar-thumb { background: ${colors.faint}; border-radius: 8px; }
  a { color: inherit; }
  button { font-family: inherit; }
  @keyframes fadeUp { from { opacity:0; transform:translateY(24px); } to { opacity:1; transform:translateY(0); } }
  @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
  .fade-in { animation: fadeUp 0.8s ease both; }
  .fade { animation: fadeIn 0.35s ease; }
  .car-card { transition: transform 0.25s ease, box-shadow 0.25s ease; }
  .car-card:hover { transform: translateY(-6px); box-shadow: 0 20px 40px rgba(0,0,0,0.1); }
  .car-card:hover .car-card-img { transform: scale(1.06); }
  .car-card-img { transition: transform 0.5s ease; }
  .btn-hover:hover { opacity: 0.88; }
  .link-hover:hover { color: ${colors.red} !important; }
  .whatsapp-fab { transition: transform 0.2s ease; }
  .whatsapp-fab:hover { transform: scale(1.08); }
  .form-field:focus { border-color: ${colors.red} !important; background: #fff !important; }
  select.form-field { cursor: pointer; }
  .thumb { transition: outline-color 0.2s ease, opacity 0.2s ease; }
  img { max-width: 100%; }
  .gallery-grid > *, .about-grid > *, .contact-grid > *, .cars-grid > *, .specs-grid > * { min-width: 0; }
  @media (max-width: 900px) {
    .nav-links { display: none !important; }
    .hamburger { display: flex !important; }
    .about-grid { grid-template-columns: 1fr !important; gap: 36px !important; }
    .contact-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
    .gallery-grid { grid-template-columns: 1fr !important; }
    .stats-row { flex-wrap: wrap !important; }
  }
  @media (max-width: 600px) {
    .section-pad { padding: 56px 20px !important; }
    .hero-pad { padding: 0 20px !important; }
    .cars-grid { grid-template-columns: 1fr !important; }
    .specs-grid { grid-template-columns: 1fr 1fr !important; }
    .main-photo { height: 260px !important; }
    .hide-mobile { display: none !important; }
  }
`;
